import { panelActions } from '@store/panelStore';
import React from 'react';
import { useEffect } from 'react';
import { useAppDispatch } from '@services/hooks/helperHooks';
import { Navigate } from 'react-router';
import { auth } from '@services/auth';

const Logout: React.FC = () => {

    const dispatch = useAppDispatch();
    useEffect(() => {
        auth().signOut();
        dispatch(panelActions.clearVariables());
    }, [dispatch]);

    return (
        <Navigate to="/auth/" replace />
    )
}

export default Logout;